module.exports = __webpack_public_path__ + "static/media/sensible.ce4a814.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sensible.m4a
// module id = nJfM
// module chunks = 1